/* import __COLOCATED_TEMPLATE__ from './appointment-cancelled.hbs'; */
import { classNames } from '@ember-decorators/component';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './appointment-cancelled.module.scss';

@classic
@classNames(styles.component)
export default class RequestCancelledAppointmentCancelled extends Component {
  @service session;
}
